import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { User, Eye, EyeOff, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FreelancerAuthPage() {
  const [mode, setMode] = useState("login");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", full_name: "", title: "" });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") {
        const res = await axios.post(`${API}/freelancer-auth/login`, {
          email: form.email,
          password: form.password,
        });
        localStorage.setItem("freelancer_token", res.data.token);
        localStorage.setItem("freelancer_slug", res.data.slug);
        toast.success("Giriş başarılı!");
        navigate("/freelancer-panel");
      } else {
        if (!form.full_name) {
          toast.error("Ad Soyad gerekli");
          setLoading(false);
          return;
        }
        const res = await axios.post(`${API}/freelancer-auth/register`, {
          email: form.email,
          password: form.password,
          full_name: form.full_name,
          title: form.title || "Freelancer",
        });
        localStorage.setItem("freelancer_token", res.data.token);
        localStorage.setItem("freelancer_slug", res.data.slug);
        toast.success("Kayıt başarılı!");
        navigate("/freelancer-panel");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#1B4F72]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <User className="w-8 h-8 text-[#1B4F72]" />
          </div>
          <h1 className="text-2xl font-bold text-stone-900 font-serif">Freelancer Portalı</h1>
          <p className="text-stone-500 text-sm mt-1">Portfolyonuzu sergileyin, iş ilanlarına başvurun</p>
        </div>

        <div className="bg-white rounded-xl border border-stone-200 p-6 shadow-sm">
          <div className="flex mb-6 bg-stone-100 rounded-lg p-1">
            <button
              onClick={() => setMode("login")}
              className={`flex-1 py-2 text-sm font-medium rounded-md transition-colors ${
                mode === "login" ? "bg-white shadow-sm text-stone-900" : "text-stone-500"
              }`}
            >
              GİRİŞ YAP
            </button>
            <button
              onClick={() => setMode("register")}
              className={`flex-1 py-2 text-sm font-medium rounded-md transition-colors ${
                mode === "register" ? "bg-white shadow-sm text-stone-900" : "text-stone-500"
              }`}
            >
              KAYIT OL
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {mode === "register" && (
              <>
                <div>
                  <Label className="text-xs text-stone-500">AD SOYAD</Label>
                  <Input
                    value={form.full_name}
                    onChange={(e) => setForm({ ...form, full_name: e.target.value })}
                    placeholder="Adınız Soyadınız"
                    className="mt-1"
                    required
                    data-testid="freelancer-name"
                  />
                </div>
                <div>
                  <Label className="text-xs text-stone-500">ÜNVAN</Label>
                  <Input
                    value={form.title}
                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                    placeholder="3D Designer, Stand Tasarımcısı..."
                    className="mt-1"
                    data-testid="freelancer-title"
                  />
                </div>
              </>
            )}

            <div>
              <Label className="text-xs text-stone-500">E-POSTA</Label>
              <Input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="ornek@email.com"
                className="mt-1"
                required
                data-testid="freelancer-email"
              />
            </div>

            <div>
              <Label className="text-xs text-stone-500">ŞİFRE</Label>
              <div className="relative mt-1">
                <Input
                  type={showPassword ? "text" : "password"}
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  placeholder="••••••••"
                  required
                  data-testid="freelancer-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1B4F72] hover:bg-[#154360] h-11"
              data-testid="freelancer-submit"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : mode === "login" ? "GİRİŞ YAP" : "KAYIT OL"}
            </Button>
          </form>

          <div className="mt-6 pt-4 border-t border-stone-100 text-center text-xs text-stone-400">
            <Link to="/" className="hover:text-[#1B4F72]">Ana Sayfaya Dön</Link>
            <span className="mx-2">·</span>
            <Link to="/giris" className="hover:text-[#1B4F72]">Firma Girişi</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
